import {
    orderListTable,
    runningTasksListTable,
    documentListTable,
    letterListTable,
    errorLetterListTable,
    preprocessListTable
} from "./tableConfig";

// http request config
const httpRequest = {
    serverAddress: process.env.REACT_APP_SERVER_ADDRESS,
    port: process.env.REACT_APP_SERVER_PORT,
    serverPath: process.env.REACT_APP_SERVER_PATH
};

// TimeOut request
const requestTimeOut = 600000;

// baseUrlRouter
const baseUrlRouter = process.env["PUBLIC_URL"]
    ? process.env["PUBLIC_URL"] + "/"
    : "/";
const baseAppRouter = baseUrlRouter + "app/";

// daoRoute
const daoRoute = {
    app: {
        getConfig: "branding/?applicationURL=:url",
        getI18n: "i18n/:baseName/?locale=:locale",
        getAnnouncement: "/branding/announcement"
    },
    login: {
        login: "authentication/authenticate",
        logout: "authentication/logout",
        checkAuthenticate: "/authentication/check"
    },
    upload: {
        postUrl: "files",
        postArchiveUrl: "files/archive"
    },
    tasks: {
        getTasks: "/fileprocessing",
        getTasksByDate: "/fileprocessing/?fromDate=:from",
        reprocessTask: "/fileprocessing/reprocess/:taskId",
        cancelTask: "/fileprocessing/cancel/:taskId",
        getTaskSubmittedFile: "/fileprocessing/submitted/:taskId",
        getTaskErrorMessage: "/fileprocessing/error/:taskId",
        getTaskFromTaskId: "/fileprocessing/:taskId",
        getInsert: "/fileprocessing/insert/:insertId"
    },
    orders: {
        createOrder: "/orders",
        getOrderListFromTaskId: "/orders/?fileProcessingId=:taskId",
        getOrderProofFile: "/orders/proof/:orderId",
        getOrderInputFile: "/orders/input/:orderId",
        validateOrder: "/orders/validate/:orderId",
        rejectOrder: "/orders/reject/:orderId",
        validateMultipleOrders: "/orders/validate",
        rejectMultipleOrders: "/orders/reject"
    },
    users: {
        getUserlist: "/users",
        savePreferences: "/users/preferences",
        getConfigurationJson: "/users/configuration/:configId",
        getAdminConfigurationJson:
            "/users/configuration/:configId/?targetUserId=:targetUserId"
    },
    documents: {
        getDocumentListFromTaskId: "/documents?fileProcessingId=:taskId",
        getDocumentListFromOrderId: "/documents?orderId=:orderId"
    },
    letter: {
        getEnvelopeList: "/envelopes/?fileProcessingId=:taskId",
        getEnvelopeDocumentFile: "/envelopes/document/:letterId",
        getMailingReceiptFile: "/envelopes/mailingReceipt/:letterId",
        getReturnReceiptFile: "/envelopes/returnReceipt/:letterId",
        rejectEnvelopes: "/envelopes/reject",
        unrejectEnvelopes: "/envelopes/unreject"
    },
    pomui: {
        getConfigs: "/pomui/configs", //GET
        updateConfig: "/pomui/configs", //POST
        getConfigParameters: "/pomui/configs/:configName/parameters",
        updateConfigParameter: "/pomui/configs/:configName/parameters",
        deleteConfigParameter:
            "/pomui/configs/:configName/parameters/:paramName",
        getConfigSettings: "/pomui/configs/:configName/settings", //GET
        updateConfigSettings: "/pomui/configs/:configName/settings", //POST
        getResourceFile: "/pomui/resources?relativeFilePath=:relativeFilePath",
        uploadResourceFile:
            "/pomui/resources?relativeFilePath=:relativeFilePath",
        exportConfig: "/pomui/export/:configId",
        importConfig: "/pomui/import"
    }
};

// I18N
const baseName = "labels_frontend1";

// Pagination
const configPagination = {
    lines: 15
};

// Log depth
const configLog = {
    info: false,
    log: false,
    warn: true,
    error: true
};

export {
    requestTimeOut,
    configLog,
    httpRequest,
    baseUrlRouter,
    baseAppRouter,
    daoRoute,
    configPagination,
    baseName,
    orderListTable,
    runningTasksListTable,
    documentListTable,
    letterListTable,
    errorLetterListTable,
    preprocessListTable
};



// WEBPACK FOOTER //
// ./src/utils/config.js